import { Button } from '@mui/material'
import { useParams, Link as RouterLink } from 'react-router-dom'

import { joinAbsRoute } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ROUTES } from 'src/constants'
import { ETranslationNs } from 'src/types'

interface IProps {
  itemId: string
}

export const NavButton = ({ itemId }: IProps) => {
  const { accountId } = useParams()

  const navigateTo = accountId
    ? joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.SCANS_CREATE + `?draftId=${itemId}`)
    : joinAbsRoute(ROUTES.SCANS_CREATE + `?draftId=${itemId}`)

  return (
    <Button component={RouterLink} to={navigateTo}>
      <HelperWrapper t="scan-choose-button-text" ns={ETranslationNs.Scans} />
    </Button>
  )
}
